import React, { createRef } from 'react';
import { createRoot } from 'react-dom/client';
import { LeadPopGame } from './game/components/LeadPopGame.jsx';

export function createNoopHandle() {
    const noop = () => {};
    return {
        start: noop,
        pause: noop,
        resume: noop,
        skip: noop,
        finish: noop,
        completeSession: noop,
        spawnBackendLead: noop,
        setOptions: noop,
        destroy: noop,
    };
}

export function createLeadPop(element, options = {}) {
    if (!element) return createNoopHandle();

    let destroyed = false;
    let currentOptions = { ...options };
    const gameRef = createRef();
    const root = createRoot(element);

    const render = (nextOptions) => {
        currentOptions = { ...nextOptions };
        root.render(React.createElement(LeadPopGame, { ref: gameRef, ...currentOptions }));
    };

    render(currentOptions);

    function safeCall(methodName, ...args) {
        if (destroyed) return undefined;
        const api = gameRef.current;
        const method = api?.[methodName];
        if (typeof method === 'function') {
            return method(...args);
        }
        return undefined;
    }

    return {
        start() {
            return safeCall('start');
        },
        pause() {
            return safeCall('pause');
        },
        resume() {
            return safeCall('resume');
        },
        skip() {
            return safeCall('skip');
        },
        finish() {
            return safeCall('finish');
        },
        completeSession() {
            return safeCall('completeSession');
        },
        spawnBackendLead(reviewRow) {
            return safeCall('spawnBackendLead', reviewRow);
        },
        setOptions(partial = {}) {
            if (destroyed) return;
            render({ ...currentOptions, ...partial });
        },
        destroy() {
            if (destroyed) return;
            destroyed = true;
            try {
                root.unmount();
            } catch (error) {
                console.warn('[lead-pop] Error while unmounting', error);
            }
        },
    };
}
